@import url('https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css');

.image-container {
  position: relative;
  display: inline-block;
}

/* Desktops */
@media only screen and (min-device-width: 992px) {
  .fast-help-fashion-name {
    position: absolute;
    top: 69.5%;
    left: 46%;
    transform: translate(-50%, -50%);
    font-family: 'Arial';
    font-size: 1.4rem;
    margin: 0;
    text-align: center;
    width: 100%;
    pointer-events: none;
    white-space: nowrap;
    color: white;
  }

  .fast-help-fashion-name .initial {
    display: inline-block;
    line-height: 1;
    vertical-align: baseline;
  }

  .fast-help-fashion-name .initial-2 {
    font-size: 1.25em;
  }
}

/* ----------- iPhone 6, 6S, 7 and 8 ----------- */
/* Portrait */
@media only screen and (min-device-width: 375px) and (max-device-width: 667px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) {
  .fast-help-fashion-name {
    position: absolute;
    top: 69%;
    left: 46%;
    transform: translate(-50%, -50%);
    font-family: 'Arial';
    font-size: 1.5rem;
    margin: 0;
    text-align: center;
    width: 100%;
    pointer-events: none;
    white-space: nowrap;
    color: white;
  }
}

/* ----------- iPhone X ----------- */
/* Portrait */
@media only screen and (min-device-width: 375px) and (max-device-width: 812px) and (-webkit-min-device-pixel-ratio: 3) and (orientation: portrait) {
  .fast-help-fashion-name {
    position: absolute;
    top: 69%;
    left: 46%;
    transform: translate(-50%, -50%);
    font-family: 'Arial';
    font-size: 1.5rem;
    margin: 0;
    text-align: center;
    width: 100%;
    pointer-events: none;
    white-space: nowrap;
  }
}
